import React, { useState, useMemo, useEffect } from 'react';
import { Select, Card } from 'antd';
import { stringMixin } from "../../utils/strings";
import { ComparisonRowTitleComponent, colorTableRow } from "./common";
import DraggableTable from "../../components/DraggableTable";

const { Option } = Select;
const TIME_FRAMES = ['1_yr', '3_yr', '5_yr'];

const BenchmarkMetrics = ({ tickerData, selectedBenchmark }) => {
  const [selectedTimeFrame, setSelectedTimeFrame] = useState('1_yr');
  const [data, setData] = useState([]);

  useEffect(() => {
    const newData = Object.entries(tickerData)
      .map(([symbol, data]) => ({
        key: symbol,
        symbol,
        ...data
      }))
      .filter((x) => x.symbol !== selectedBenchmark);
    setData(newData);
  }, [tickerData, selectedBenchmark]);

  const columns = useMemo(() => {
    const firstTicker = Object.values(tickerData)[0];
    if (!firstTicker) return [];
    if (!firstTicker.stats?.benchmarks?.[selectedBenchmark]) return [];

    const metrics = Object.keys(firstTicker.stats.benchmarks[selectedBenchmark])
      .filter(key => key.endsWith(selectedTimeFrame))
      .map(key => key.replace(`_${selectedTimeFrame}`, ''));

    return [
      {
        title: 'Symbol',
        dataIndex: 'symbol',
        key: 'symbol',
        render: (_, record) => <ComparisonRowTitleComponent symbol={record.symbol} record={record} />
      },
      ...metrics.map(metric => ({
        title: metric,
        dataIndex: ['stats', 'benchmarks', selectedBenchmark, `${metric}_${selectedTimeFrame}`],
        key: metric,
        render: (value) => (metric === 'upside' || metric === 'downside') ? value?.toFixed(1) : typeof value === 'number' ? stringMixin.pct(value) : (value ?? 'N/A'),
        sorter: (a, b) => (b.stats?.benchmarks?.[selectedBenchmark]?.[`${metric}_${selectedTimeFrame}`] ?? 0) - (a.stats?.benchmarks?.[selectedBenchmark]?.[`${metric}_${selectedTimeFrame}`] ?? 0),
      }))
    ];
  }, [tickerData, selectedBenchmark, selectedTimeFrame]);

  return (
    <Card
      bordered={false}
      title={`Benchmark Metrics (${selectedBenchmark.toUpperCase()})`}
      style={{maxWidth: '95%'}}
      extra={
        <Select
          value={selectedTimeFrame}
          style={{ width: 120, marginBottom: 16 }}
          onChange={setSelectedTimeFrame}
        >
          {TIME_FRAMES.map(timeFrame => (
            <Option key={timeFrame} value={timeFrame}>{timeFrame.replace('_', ' ')}</Option>
          ))}
        </Select>
      }
    >
      <DraggableTable
        columns={columns}
        data={data}
        setData={setData}
        tableProps={{ onRow: colorTableRow, pagination: false, scroll: {y: 800} }}
      />
    </Card>
  );
};

export default BenchmarkMetrics;